export interface QueryParams {
  [key: string]: any;
}
